import { trigger } from '@angular/animations';

export function toggleContentAnimation() {
  return trigger('toggleContentAnimation', [
  ]);
}
